import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FuelTankDto } from 'src/app/shared/flight-log-api/fuel-tanks/fuel-tank-client.model';
import { assertNotNullOrWhitespace } from 'src/util/values';
import { FlightLogApiConfiguration, FLIGHT_LOG_API_CONFIG } from '../flight-log-api-configuration';

@Injectable({ providedIn: 'root' })
export class FuelTankHttpClient {
  public _cache: FuelTankDto[] = [];
  constructor(
    @Inject(FLIGHT_LOG_API_CONFIG) private config: FlightLogApiConfiguration,
    private http: HttpClient,
  ) {}

  public getById(fuelTankId: string): Observable<FuelTankDto> {
    assertNotNullOrWhitespace(fuelTankId, 'fuelTankId');
    return this.http.get<FuelTankDto>(this._url(`fueltanks/${fuelTankId}`));
  }

  public getAll(refreshCache = false): Observable<FuelTankDto[]> {
    const useCache = !refreshCache && this._cache.length !== 0;
    if (useCache) {
      return of(this._cache);
    } else {
      return this.http.get<FuelTankDto[]>(this._url('fueltanks')).pipe(
        tap((_) => {
          this._cache = _;
        }),
      );
    }
  }

  private _url(path: string) {
    return this.config.baseUri + '/api/' + path;
  }
}
